import * as types from "./ActionTypes";
import InitialState from "Store/InitialState";
import { toPlainText } from "./utils";

export default function MaintenanceReducer(state = InitialState.maintenance, action) {
  switch (action.type) {
    case types.MAINTENANCE_STATUS_RECEIVED: {
      const status = action.payload;
      const active = Boolean(status.active);
      const bypass = Boolean(status.bypass);
      const serverTime = Date.parse(status.server_time);
      return {
        ...state,
        active,
        bypass,
        source: status.source || null,
        messageText: status.message_text || "",
        expectedEnd: status.expected_end || null,
        upcoming: status.upcoming || null,
        pollSeconds: Number(status.poll_seconds) > 0 ? Number(status.poll_seconds) : state.pollSeconds,
        serverOffsetMs: Number.isNaN(serverTime) ? state.serverOffsetMs : serverTime - action.receivedAt,
        checkedAt: action.receivedAt,
        shown: state.shown || (active && !bypass),
      };
    }

    case types.MAINTENANCE_DETECTED: {
      // Every in-flight call fails at once when the site closes; only the
      // first one needs to change anything.
      if (state.active && !state.bypass) return state;
      const body = action.payload;
      return {
        ...state,
        active: true,
        bypass: false,
        source: body.source || state.source,
        messageText: body.message_text || toPlainText(body.detail) || state.messageText,
        expectedEnd: body.expected_end || state.expectedEnd,
        detectedAt: action.receivedAt,
        shown: true,
      };
    }

    default:
      return state;
  }
}
